

namespace Gordic.Epk.WebControls {

    export class GEpkVisualPlacemenet {

        public setVisualPlacementMenuParams(cnt: GContentType<GEpkDbParamsNew>, opt: { menuBar: MenuParams[], row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, fileSelectionRowFc: Function }) {

            // vizuální umístění není parametricky povoleno
            if (cnt.EpkParams.gin_pdf_pictpos === 0 || cnt.EpkParams.epk_povumipod === 0)
                return;

            // detail žádosti nesmí být pouze ke čtení a vybraná žádost musí být ve stavu K VYŘÍZENÍ
            if (cnt.ReadOnly === true && opt.row.zpus_vyriz !== 0)  
                return;

            let fileSelectionRow = opt.fileSelectionRowFc();

            if (fileSelectionRow != null && fileSelectionRow.File != null) {

                let ixb = fileSelectionRow.File.Ixb;
                let visualParams: MenuParams | null = null;
                let idParam = "idVisualPlacement";
                let idBadge = "idBadgeVP";
                let badgeVisual = new GObservableObject({ id: idBadge, value: "", tooltip: "" });
                let menuBar = opt.menuBar;

                var isHere = false;
                for (var i = 0; i < menuBar.length; i++) {
                    var menuParams = menuBar[i];
                    if (menuParams.id === idParam) {
                        isHere = true;
                        visualParams = menuParams;
                        break;
                    }
                }

                // povolení možnosti umístění vizuálního podpisu
                var enabled = true;
                // nesmí se jedna o související soubor
                if (fileSelectionRow.File.IsSouvis === true)            
                    enabled = false;

                if (isHere === false) {
                    var params: MenuParams = {
                        id: idParam,
                        badge: badgeVisual,
                        action: cnt.actions.add(new GAction({
                            enabled: enabled,
                            name: "actVisualPlacement",
                            caption: "jres:32000551", //RC 32000551 : Umístění podpisu
                            tooltip: "jres:32000884", //RC 32000884 : Umístění vizuálního podpisu
                            icon: "fa-map-marker",
                            run: (ev, ctx) => {
                                let file = opt.fileSelectionRowFc();
                                if (file != null && file.File != null) {
                                    new GEpkActionsService().addSignaturePlacement(cnt, opt.row, file.File.Ixb, file.File.IsFavorite)
                                        .then((state) => {
                                            this.updateBadge(state, visualParams, idBadge);
                                        })
                                }
                            }
                        }))
                    };
                    visualParams = params;
                    menuBar.push(params);
                }
                else {

                    if (cnt.actions.actVisualPlacement != null) {
                        cnt.actions.actVisualPlacement.enabled(enabled);
                    }

                }

                this.setVisualPlacementBadge(cnt, { idBadge: idBadge, idParam: idParam, visualParams: visualParams, row: opt.row, ixb: ixb });

            }
            else {
                console.error("Vizuální umístění pro daný soubor není k dispozici.");
            }
            return;
        }

        private setVisualPlacementBadge(cnt: GContentType<any>, opt: { visualParams: MenuParams | null, idParam: string, idBadge: string, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, ixb: string }) {
            if (opt.visualParams != null) {
                new GEpkActionsService().updateBadgeVisualPlacement(cnt, opt.row, opt.ixb)
                    .then((state) => {
                        this.updateBadge(state, opt.visualParams!, opt.idBadge!);
                    });
            }
        }

        private updateBadge(state: boolean, visualParams: MenuParams | null, idBadge: string) {
            if (visualParams != null) {
                var badge = visualParams.badge as GObservableObject<GBadgeOptions>;
                if (badge != null)
                    badge.update({ id: idBadge, value: state === true ? "jres:32000595" : "", tooltip: state === true ? "jres:32000596" : "" }); //RC 32000595 : Ručně
            }
            
        }

    }

}


